import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { ConfirmModal } from "../../dialogs/ConfirmModal"

const useStyles = makeStyles()(() => ({
    classNameOverride: {
        padding: "1.25rem 1.5rem 3.25rem",
    },
}))

type CreateOrderCloseConfirmDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    onDiscard: () => void
}>

export function CreateOrderCloseConfirmDialog({ open, onClose, onDiscard }: CreateOrderCloseConfirmDialogProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="create-order-close-confirm-dialog" attrs={{ title: true, buttonLabelSubmit: true }}>
            <ConfirmModal
                open={open}
                onClose={onClose}
                handleClick={onDiscard}
                title="Discard changes"
                message={
                    <LocalizedStrict id="create-order-close-confirm-dialog-message">
                        <Typography variant="body1">
                            If you click Discard, all entered information will be lost.
                        </Typography>
                    </LocalizedStrict>
                }
                buttonLabelSubmit="Discard"
                classNameOverride={classes.classNameOverride}
            />
        </LocalizedStrict>
    )
}
